// extracted by mini-css-extract-plugin
module.exports = {"label":"index_label__UGVMB","div":"index_div__q7JPW","input":"index_input__QheRS","title":"index_title__r_jdA","content":"index_content__F_fBM"};